
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref0de"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref0de"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ihnPQ", function(module, exports) {

$parcel$export(module.exports, "checkComplexity", () => $3578d48e6620f1ea$export$2628422de354bd82);
$parcel$export(module.exports, "checkPassword", () => $3578d48e6620f1ea$export$829bde5c78b59082);
function $3578d48e6620f1ea$export$2628422de354bd82(plainPassword) {
    const errors = [];
    if (plainPassword.length < 8) errors.push('Password must be at least 8 characters long.');
    // more rules here;
    return errors;
}
function $3578d48e6620f1ea$export$829bde5c78b59082(password) {
    const errors = [];
    if (password.length < 8) errors.push('Must be at least 8 characters long.');
    if (!/[A-Z]/.test(password)) errors.push('Must contain at least one uppercase letter.');
    if (!/[a-z]/.test(password)) errors.push('Must contain at least one lowercase letter.');
    if (!/[0-9]/.test(password)) errors.push('Must contain at least one digit.');
    if (!/[^A-Za-z0-9]/.test(password)) errors.push('Must contain at least one special character.');
    return errors;
}

});

parcelRegister("f3ENG", function(module, exports) {

$parcel$export(module.exports, "checkUsername", () => $41b51e0a9b00ff83$export$4929d86c6e4e281e);
function $41b51e0a9b00ff83$export$4929d86c6e4e281e(username) {
    const errors = [];
    if (!/\S+@\S+\.\S+/.test(username)) errors.push('Must use email format: email@example.com');
    // more rules here;
    return errors;
}
function $41b51e0a9b00ff83$export$eab31b5b7191a1ae(username) {
    const errors = [];
    if (username.length < 5) errors.push('Username must be at least 5 characters long.');
    if (username.length > 20) errors.push('Username must be at most 20 characters long.');
    return errors;
}
function $41b51e0a9b00ff83$export$e2eb4ecab7fa711d(username) {
    const errors = [];
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(username)) errors.push('Username can only contain letters, numbers, dots, underscores, and hyphens.');
    return errors;
}

});

parcelRegister("huIqw", function(module, exports) {

$parcel$export(module.exports, "FieldError", () => $feb1720a7ad5f54f$export$f551688fc98f2e09);
class $feb1720a7ad5f54f$export$f551688fc98f2e09 {
    errors = new Set();
    set(errKey, inputField, label, labelText) {
        inputField.classList.add("input-error");
        label.classList.remove("hidden");
        label.innerHTML = labelText;
        this.errors.add(errKey);
    }
    remove(errKey, field, label) {
        field.classList.remove("input-error");
        label.classList.add("hidden");
        this.errors.delete(errKey);
    }
    isEmpty() {
        return this.errors.size === 0;
    }
}

});


var $ihnPQ = parcelRequire("ihnPQ");

var $f3ENG = parcelRequire("f3ENG");

var $huIqw = parcelRequire("huIqw");
const $3eeaa9ed738530cd$var$passwordField = document.getElementById('password');
const $3eeaa9ed738530cd$var$passwordInvalidLabel = document.getElementById('invalid-password');
const $3eeaa9ed738530cd$var$togglePasswordVisibilityBtn = document.getElementById('toggle-password-visibility');
const $3eeaa9ed738530cd$var$passwordEyeIcon = document.getElementById('password-eye-icon');
const $3eeaa9ed738530cd$var$passwordEyeOffIcon = document.getElementById('password-eye-off-icon');
const $3eeaa9ed738530cd$var$emailField = document.getElementById('email');
const $3eeaa9ed738530cd$var$emailInvalidLabel = document.getElementById('invalid-email');
const $3eeaa9ed738530cd$var$agreeTosCheckBox = document.getElementById('agree-tos');
const $3eeaa9ed738530cd$var$submitBtn = document.getElementById('form-submit');
const $3eeaa9ed738530cd$var$errors = new (0, $huIqw.FieldError)();
// Update the submit button state based on current validations
function $3eeaa9ed738530cd$var$updateSubmitBtn() {
    if ($3eeaa9ed738530cd$var$errors.isEmpty() && $3eeaa9ed738530cd$var$emailField.value.length > 0 && $3eeaa9ed738530cd$var$passwordField.value.length > 0 && $3eeaa9ed738530cd$var$agreeTosCheckBox.checked) $3eeaa9ed738530cd$var$submitBtn?.classList.remove('btn-disabled');
    else $3eeaa9ed738530cd$var$submitBtn?.classList.add('btn-disabled');
}
$3eeaa9ed738530cd$var$agreeTosCheckBox.addEventListener('change', (_)=>{
    $3eeaa9ed738530cd$var$updateSubmitBtn();
});
$3eeaa9ed738530cd$var$emailField.addEventListener('input', (_)=>{
    const usernameFailures = (0, $f3ENG.checkUsername)($3eeaa9ed738530cd$var$emailField.value);
    if (usernameFailures.length > 0) {
        const formattedErrors = usernameFailures.join('<br>');
        $3eeaa9ed738530cd$var$errors.set('invalid-email', $3eeaa9ed738530cd$var$emailField, $3eeaa9ed738530cd$var$emailInvalidLabel, formattedErrors);
    } else $3eeaa9ed738530cd$var$errors.remove('invalid-email', $3eeaa9ed738530cd$var$emailField, $3eeaa9ed738530cd$var$emailInvalidLabel);
    $3eeaa9ed738530cd$var$updateSubmitBtn();
});
// Validate password complexity on input
$3eeaa9ed738530cd$var$passwordField.addEventListener('input', (_)=>{
    const complexityFailures = (0, $ihnPQ.checkPassword)($3eeaa9ed738530cd$var$passwordField.value);
    if (complexityFailures.length > 0) {
        const formattedErrors = complexityFailures.join('<br>');
        $3eeaa9ed738530cd$var$errors.set('password-complexity-failure', $3eeaa9ed738530cd$var$passwordField, $3eeaa9ed738530cd$var$passwordInvalidLabel, formattedErrors);
    } else $3eeaa9ed738530cd$var$errors.remove('password-complexity-failure', $3eeaa9ed738530cd$var$passwordField, $3eeaa9ed738530cd$var$passwordInvalidLabel);
    $3eeaa9ed738530cd$var$updateSubmitBtn();
});
// Toggle password visibility
$3eeaa9ed738530cd$var$togglePasswordVisibilityBtn?.addEventListener('click', ()=>{
    if (!$3eeaa9ed738530cd$var$passwordField) return;
    const isHidden = $3eeaa9ed738530cd$var$passwordField.type === 'password';
    $3eeaa9ed738530cd$var$passwordField.type = isHidden ? 'text' : 'password';
    if ($3eeaa9ed738530cd$var$passwordEyeIcon && $3eeaa9ed738530cd$var$passwordEyeOffIcon) {
        if (isHidden) {
            $3eeaa9ed738530cd$var$passwordEyeIcon.classList.add('hidden');
            $3eeaa9ed738530cd$var$passwordEyeOffIcon.classList.remove('hidden');
            $3eeaa9ed738530cd$var$togglePasswordVisibilityBtn.setAttribute('aria-label', 'Hide password');
        } else {
            $3eeaa9ed738530cd$var$passwordEyeIcon.classList.remove('hidden');
            $3eeaa9ed738530cd$var$passwordEyeOffIcon.classList.add('hidden');
            $3eeaa9ed738530cd$var$togglePasswordVisibilityBtn.setAttribute('aria-label', 'Show password');
        }
    }
});
// set initial state for terms checkbox
$3eeaa9ed738530cd$var$agreeTosCheckBox.checked = false;


//# sourceMappingURL=register.js.map
